import Cookies from 'js-cookie';
import { toast } from 'react-hot-toast';
import { useLogoutMutation } from '@/store/api/authApi';

export const useLogout = () => {
  const [logoutUser, { isLoading }] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutUser().unwrap();

      toast.success('User logged out successfully!');

      Cookies.remove('access-token');

      window.location.href = '/';
    } catch (error) {
      console.log(error);
      toast.error('Logout failed');
    }
  };

  return {
    handleLogout,
    isLoading,
  };
};
